/**
 * RequestIcon/index.js
 * desc: system icon for request step type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const RequestIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="request icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.request.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 18" xmlns="http://www.w3.org/2000/svg"><path d="M17.123 0L22 4.889l-4.877 4.889V6.11H8.556V3.667h8.567V0zM0 12.222l4.877-4.889V11h8.567v2.445H4.877v3.666L0 12.222z"/></svg>
    </IconButton>
);


export default RequestIcon;
